import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Modal from "./Modal";

const Covered = ({ display, product, ...props }) => {
  const [coveredData, setCoveredData] = useState();
  const [coveredLoading, setCoveredLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [openExclusions, setOpenExclusions] = useState(false);
  useEffect(() => {
    setCoveredLoading(false);
    setCoveredData(props.covered);
  }, []);
  const travelCoveredItems = [
    "Care for Minor Children",
    "Compassionate Visit",
    "Medicine Delivery",
    "Lost Travel Documents Support",
  ];
  return (
    <>
      <div className="max-w-md p-5 max-w-full bg-white shadow rounded-lg">
        <div>
          <h2 className={`text-gray-800 text-sm font-bold leading-snug ${props.coverType !== "international" ? "" : "text-center"}`}>
            {props.subTitle}
          </h2>
          {(props.title === "notCovered" && props.coverType === "international") && (
            <p className=" text-xs leading-snug ml-3 mt-3">
              The benefits come with certain limitations. Coverage will not be
              provided in the following situations:
            </p>
          )}
          {coveredLoading || (
            <>
              {coveredData.map((data, index) => (
                <div className="relative flex" key={index}>
                  <div className="grid grid-cols-6 gap-4 mt-5">
                    {props.title === "notCovered" && (
                      <div className="covered-image-white self-center">
                        <img
                          src={data.imageUrl}
                          alt="covered-notcovered"
                          className="covered-icon"
                        />
                      </div>
                    )}
                    {props.title === "notCovered" || (
                      <div className="covered-image covered-image-white ">
                        <img
                          src={data.imageUrl}
                          alt="covered-notcovered"
                          className="covered-icon"
                        />
                      </div>
                    )}

                    <div key={index} className="self-center col-span-5">
                      {props.title === "notCovered" || (
                        <>
                          <h5 className="ml-3 font-semibold mb-1 text-sm leading-tight">
                            {data.title}
                          </h5>

                          <p className="text-gray-600 text-xs leading-snug ml-3">
                            {data.description}
                          </p>
                        </>
                      )}
                       {(props.title === "notCovered" && props.coverType!=="international") && (
                        <>
                           <h5 className="ml-3 font-semibold mb-1 text-sm leading-tight">
                            {data.title}
                          </h5>
                        </>
                      )}
                      {(props.title === "notCovered") && (
                        <>
                          <p className="text-gray-600 text-xs leading-snug">
                            {data.description}
                          </p>
                        </>
                      )}
                     
                      {index == coveredData.length - 1 &&
                        props.title == "covered" && props.coverType=="international" && (
                          <ul className="ml-5">
                            {travelCoveredItems.map((item, idx) => (
                              <li key={item} className="flex items-center">
                                <span className="text-gray-600 mr-2">✓</span>
                                <p className="text-gray-600 text-xs leading-snug">
                                  {item}
                                </p>
                              </li>
                            ))}
                          </ul>
                        )}
                    </div>
                  </div>
                </div>
              ))}
              {(props.title === "covered" && props.coverType === "international") && (
                <p className="text-gray-600 text-xs leading-snug ml-3 mt-3">
                  See all the benefits and coverage waiting for you — click{" "}
                  <span
                    className="text-blue-500 text-xs font-bold underline cursor-pointer"
                    onClick={() => setOpen(true)}
                  >
                    here
                  </span>{" "}
                  to learn more.
                </p>
              )}
              {(props.title === "notCovered" && props.coverType === "international") && (
                <p className="text-gray-600 text-xs leading-snug ml-3 mt-3">
                  Know more about the policy’s general exclusions, check{" "}
                  <span
                    className="text-blue-500 text-xs font-bold underline"
                    onClick={() => setOpenExclusions(true)}
                  >
                    here
                  </span>{" "}
                  for the details.
                </p>
              )}
            </>
          )}
          <div className="mt-10">
            {display && (
              <Link
                to={{
                  pathname: "/" + props.cover.toLowerCase(),
                  state: { lob: product },
                }}
              >
                <span className="text-blue-500 text-xs font-bold underline">
                  View complete list of {props.cover}
                </span>
              </Link>
            )}
          </div>
        </div>
      </div>
      <Modal
        open={open}
        setOpen={setOpen}
        title="Travel Insurance Policy Benefits and Coverage"
      >
        <div className="max-h-96 overflow-y-auto px-4 py-2">
          <div className="space-y-4 text-sm">
            <section>
              <h3 className="font-bold text-gray-800 mb-2">
                Period of Insurance
              </h3>
              <p className="text-gray-600 mb-2">The Policy shall commence:</p>
              <p className="text-gray-600 mb-2">
                when the Policyholder leaves his/her home in the Usual Country
                of Residence to commence the travel, but not earlier than
                twenty-four (24) hours before the start date shown on the policy
                schedule as evidenced by the original departure time shown on
                the travel ticket, and ends under all other sections:
              </p>
              <ul className="list-disc list-inside text-gray-600 mb-2 ml-4">
                <li>
                  no more than 24 hours from actual date of arrival as evidenced
                  by the original arrival time shown on the travel ticket; or
                </li>
                <li>
                  no later than end date of the policy as shown in the policy
                  schedule; or
                </li>
                <li>
                  when the Policyholder is in his/her home address in the Usual
                  Country of Residence.
                </li>
              </ul>
              <p className="text-gray-600 mb-2">whichever is earlier.</p>
              <p className="text-gray-600">
                Furthermore, the Insured person is covered if diagnosed with
                COVID-19 during the insured trip or within fifteen (15) days
                prior to the scheduled trip departure date, provided travel
                insurance is taken prior to such diagnosis.
              </p>
            </section>

            <section>
              <h3 className="font-bold text-gray-800 mb-2">
                Emergency Medical Assistance
              </h3>
              <h4 className="font-semibold text-gray-700 mb-2">
                Cashless Benefits
              </h4>
              <div className="mb-4">
                <h5 className="font-semibold text-gray-700">
                  1. Medical treatment including claims due to/arising from
                  COVID-19 (with Automatic Extension of Period of Insurance)
                </h5>
                <p className="text-gray-600 mb-2">
                  Pays the usual, customary, necessary and reasonable costs of
                  hospitalization, surgery, medical fees, professional fees and
                  pharmaceutical products, prescribed by the attending doctor in
                  the event of covered illness or injury. This includes an
                  automatic extension of 10 days of period of insurance should
                  the Policyholder be hospitalized.
                </p>
                <p className="text-gray-600">
                  <strong>Exclusions:</strong> A pre-existing condition is
                  defined as a medical condition that the policyholder suffered
                  prior to taking out the insurance, whether or not the
                  Policyholder is aware of such condition. A pre-existing
                  condition may pre-dispose the Policyholder to certain medical
                  emergencies, which are exclusions from the policy.
                </p>
              </div>

              <h4 className="font-semibold text-gray-700 mb-2">
                Benefits for Reimbursement
              </h4>
              <div className="mb-2">
                <h5 className="font-semibold text-gray-700">
                  2. Hospital Income
                </h5>
                <p className="text-gray-600">
                  Provides a daily income up to ten (10) consecutive days if
                  hospitalized due to covered illness or injury.
                </p>
              </div>
              <div className="mb-4">
                <h5 className="font-semibold text-gray-700">
                  3. Emergency Dental Care
                </h5>
                <p className="text-gray-600 mb-2">
                  Provides dental assistance and pays the cost for necessary
                  emergency dental treatment of natural teeth resulting from an
                  accident.
                </p>
                <p className="text-gray-600">
                  Crowns, bridges, dentures, etc. are not understood to be
                  natural teeth. Ordinary toothaches, cavities, infections or
                  decay, dental sensitivity in the course of the policyholder's
                  trip is not covered under this policy
                </p>
              </div>
            </section>

            <section>
              <h3 className="font-bold text-gray-800 mb-2">
                Emergency Travel Assistance
              </h3>
              <h4 className="font-semibold text-gray-700 mb-2">
                Cashless Benefits
              </h4>
              <div className="space-y-3 mb-4">
                <div>
                  <h5 className="font-semibold text-gray-700">
                    4. Emergency Medical Evacuation/Repatriation
                  </h5>
                  <p className="text-gray-600 mb-1">
                    Covers transfer or repatriation, if necessary, via an
                    ambulance or the most suitable means of transport to a
                    medical facility where adequate assistance can be performed
                    in the event of an accident or a life-threatening illness.
                  </p>
                  <p className="text-gray-600">
                    •It is upon the discretion of Standard Insurance to decide
                    whether medical evacuation or medical repatriation is
                    necessary.
                  </p>
                </div>
                <div>
                  <h5 className="font-semibold text-gray-700">
                    5. Repatriation of Mortal Remains
                  </h5>
                  <p className="text-gray-600">
                    Arranges necessary transport or repatriation and pays the
                    cost of the transfer expenses to the place of internment in
                    the Philippines in the event of death due to accident or
                    illness.
                  </p>
                </div>
                <div>
                  <h5 className="font-semibold text-gray-700">
                    6. Care of Minor Children
                  </h5>
                  <p className="text-gray-600">
                    Pays for the transportation of one immediate family member
                    if Policyholder is hospitalized for more than ten (10)
                    consecutive days or is deceased, and is accompanied by a
                    minor during the trip and if no adult accompanies the said
                    minor.
                  </p>
                </div>
                <div>
                  <h5 className="font-semibold text-gray-700">
                    7. Compassionate Visit
                  </h5>
                  <p className="text-gray-600">
                    Takes charge of the transfer of an immediate family member
                    including the accommodation expenses up to the limit
                    indicated in the Plan for a maximum of twenty (20) days, if
                    admitted to hospital for more than five (5) days as a result
                    of accident or illness. This will only respond if the
                    Policyholder has no relative with him on the trip.
                  </p>
                </div>
                <div>
                  <h5 className="font-semibold text-gray-700">
                    8. Delivery of Medicine
                  </h5>
                  <p className="text-gray-600">
                    Takes charge of delivering the medicines prescribed urgently
                    by a doctor for the Policyholder during the trip. Cost of
                    medicine is excluded.
                  </p>
                </div>
              </div>

              <h4 className="font-semibold text-gray-700 mb-2">
                Benefits for Reimbursement
              </h4>
              <div className="mb-4">
                <h5 className="font-semibold text-gray-700">
                  9. Relay of Urgent Messages
                </h5>
                <p className="text-gray-600">
                  - Reimburses reasonable communication expenses incurred to
                  contact the Assistance Center.
                </p>
              </div>
            </section>

            <section>
              <h3 className="font-bold text-gray-800 mb-2">
                Travel Inconvenience Benefits
              </h3>
              <h4 className="font-semibold text-gray-700 mb-2">
                Cashless Benefits
              </h4>
              <div className="space-y-3 mb-4">
                <div>
                  <h5 className="font-semibold text-gray-700">
                    10. Loss of Travel Documents
                  </h5>
                  <p className="text-gray-600 mb-1">
                    Pays for reasonable additional hotel, travel and
                    communications expenses, flight rebooking fee (if any),
                    including cost to replace travel documents in obtaining the
                    replacement of a lost passport or visa due to theft,
                    robbery, burglary, or Acts of Nature.
                  </p>
                  <p className="text-gray-600">
                    • Any loss of passport or visa must be reported to the
                    Police or Consular representative within 24 hours. A written
                    report is required to make a claim.
                  </p>
                </div>
                <div>
                  <h5 className="font-semibold text-gray-700">
                    11. Location and Forwarding of Luggage
                  </h5>
                  <p className="text-gray-600">
                    Provides advice on reporting of delayed or missing luggage
                    and personal possessions and assists in arrangements for
                    locating them.
                  </p>
                </div>
              </div>

              <h4 className="font-semibold text-gray-700 mb-2">
                Benefits for Reimbursement
              </h4>
              <div className="space-y-3">
                <div>
                  <h5 className="font-semibold text-gray-700">
                    12. Loss of Personal Money
                  </h5>
                  <p className="text-gray-600 mb-1">
                    Reimburses personal money/cash, traveler's checks if lost or
                    stolen due to theft, robbery, burglar, Acts of Nature,
                    provided that a Police report is filed within 24 hours of
                    occurrence.
                  </p>
                  <p className="text-gray-600">
                    • Not applicable for children 15 years and younger.
                  </p>
                </div>
                <div>
                  <h5 className="font-semibold text-gray-700">
                    13. Car Rental Excess Protection
                  </h5>
                  <p className="text-gray-600">
                    Reimburses any excess or deductible if policyholder becomes
                    legally liable to pay in respect of loss or damage caused by
                    accident to the rented vehicle during the rental period.
                  </p>
                </div>
                <div>
                  <h5 className="font-semibold text-gray-700">
                    14. Trip Cancellation including claims due to/ arising from
                    COVID-19
                  </h5>
                  <p className="text-gray-600 mb-1">
                    Pays for the non-refundable portion of the travel
                    accommodation expenses, including non-refundable cruise
                    tickets and flight rebooking (if any), if the trip has to be
                    cancelled due to serious illness, serious bodily accident or
                    death sustained or serious damage caused by fire, explosion,
                    robbery or by Acts of Nature in the Usual Place of Residence
                    or at the planned destination.
                  </p>
                  <p className="text-gray-600 mb-1">
                    • Policyholder has not yet left his/her country of residence
                  </p>
                  <p className="text-gray-600">
                    • For Trip cancellation, coverage takes effect upon payment
                    of premium. The policy must have been issued at least three
                    (3) days before the trip.
                  </p>
                </div>
                <div>
                  <h5 className="font-semibold text-gray-700">
                    15. Delayed Departure (Outbound and Inbound)
                  </h5>
                  <p className="text-gray-600">
                    Pays any additional expenses incurred such as transport and
                    hotel accommodation, maintenance expense, non-refundable
                    cruise and hotel bookings (if any), if trip is delayed by at
                    least six (6) hours due to acts of nature, mechanical
                    breakdown of the carrier or sunset limitation.
                  </p>
                </div>
                <div>
                  <h5 className="font-semibold text-gray-700">
                    16. Trip Postponement
                  </h5>
                  <p className="text-gray-600">
                    Pays the non-refundable portion of travel accommodation
                    expenses, including flight rebooking fees, non-refundable
                    cruise and hotel bookings (if any), if trip is delayed by at
                    least 24 hours due to acts of nature, mechanical breakdown
                    of the carrier or sunset limitation.
                  </p>
                </div>
                <div>
                  <h5 className="font-semibold text-gray-700">
                    17. Missed Connection (Outbound and Inbound)
                  </h5>
                  <p className="text-gray-600">
                    Pays reasonable additional expenses such as prime necessity
                    expenses incurred, including the use of alternative
                    scheduled public transport services and non-refundable
                    cruise and hotel bookings (if any), if the carrier
                    contracted was delayed by six (6) hours because of acts of
                    nature, mechanical breakdown of the carrier, sunset
                    limitation and intervention by the authorities or hijackers.
                  </p>
                </div>
                <div>
                  <h5 className="font-semibold text-gray-700">
                    18. Diversion of Trip (Outbound and Inbound)
                  </h5>
                  <p className="text-gray-600">
                    Pays for the prime necessity expenses including reasonable
                    additional expenses incurred for the use of alternative
                    scheduled public transport if the carrier contracted is
                    diverted because of mechanical breakdown of the carrier,
                    acts of nature, intervention by the authorities or
                    hijackers.
                  </p>
                </div>
                <div>
                  <h5 className="font-semibold text-gray-700">
                    19. Trip Termination including claims due to/ arising from
                    COVID-19
                  </h5>
                  <p className="text-gray-600 mb-1">
                    Pays for the proportional (non-refundable) part of the
                    journey forfeited, including flight rebooking fees (if any),
                    if the trip has been cut short due to (a) serious illness,
                    serious bodily accident or death sustained by the
                    Policyholder or pre-existing illness, serious bodily
                    accident or death of immediate family member or (b)
                    burglary, fire or explosion in his/her Usual Place of
                    Residence.
                  </p>
                  <p className="text-gray-600">
                    Insured can only claim from one of these benefits namely,
                    (i) Delayed Departure (ii) Trip cancellation, (iii) Trip
                    Postponement, (iv) Missed Connection, (v) Trip Termination
                    or (vi) Diversion of Trip for the same occurrence.
                  </p>
                </div>
                <div>
                  <h5 className="font-semibold text-gray-700">
                    20. Baggage Delay
                  </h5>
                  <p className="text-gray-600">
                    Reimburses for the purchase of necessary clothing and
                    toiletries if the checked-in baggage is delayed, misdirected
                    or temporarily misplaced for more than six (6) hours from
                    the time of the arrival at the overseas destination.
                  </p>
                </div>
                <div>
                  <h5 className="font-semibold text-gray-700">
                    21. Loss or Damage Baggage
                  </h5>
                  <p className="text-gray-600 mb-1">
                    Compensates for lost or damaged checked-in baggage the
                    portion not covered by the airline baggage limit of
                    liability and indemnifies material losses if luggage or
                    personal belongings in case of theft, robbery and burglary,
                    if not checked-in.
                  </p>
                  <p className="text-gray-600">
                    • Please remember to keep all your receipts, boarding
                    passes, baggage claim tags to facilitate your claim. You
                    will also need to secure a Property Irregularity report from
                    the Airline.
                  </p>
                </div>
                <div>
                  <h5 className="font-semibold text-gray-700">22. Hijack</h5>
                  <p className="text-gray-600">
                    Provides a daily allowance for a maximum of ten (10) days
                    for each full day for the delay or interruption of the
                    journey as a result of hijack.
                  </p>
                </div>
              </div>
            </section>

            <section>
              <h3 className="font-bold text-gray-800 mb-2">
                Personal Liability Benefit
              </h3>
              <h4 className="font-semibold text-gray-700 mb-2">
                Benefit for Reimbursement
              </h4>
              <div className="mb-4">
                <h5 className="font-semibold text-gray-700">
                  23. Personal Liability
                </h5>
                <p className="text-gray-600">
                  Covers expenses that the Policyholder causes another person's
                  accidental death, bodily injury or damage to property because
                  of situations beyond the Policyholder's control while
                  traveling.
                </p>
              </div>
            </section>

            <section>
              <h3 className="font-bold text-gray-800 mb-2">
                Personal Accident Benefit
              </h3>
              <h4 className="font-semibold text-gray-700 mb-2">
                Benefits for Reimbursement
              </h4>
              <div>
                <h5 className="font-semibold text-gray-700">
                  24. Personal Accident
                </h5>
                <p className="text-gray-600">
                  Provides benefit for accidental death and permanent total
                  disability occurring during the trip.
                </p>
              </div>
            </section>
          </div>
        </div>
      </Modal>

      <Modal
        open={openExclusions}
        setOpen={setOpenExclusions}
        title="GENERAL EXCLUSIONS"
      >
        <div className="max-h-96 overflow-y-auto px-4 py-2">
          <div className="space-y-4 text-sm">
            <section>
              <h3 className="font-bold text-gray-800 mb-3">
                1. General Coverage Exclusions
              </h3>
              <p className="text-gray-600 mb-3">
                On a general basis for all the guarantees and coverage, the
                consequences of the following are excluded from the guarantee
                object of this Agreement:
              </p>

              <div className="space-y-2 ml-4">
                <div className="flex">
                  <span className="font-semibold text-gray-700 min-w-6">
                    a)
                  </span>
                  <p className="text-gray-600 ml-2">
                    Those caused directly or indirectly by the bad faith of the
                    Policyholder, by his/her participation in criminal acts, or
                    as a result of his/her fraudulent, seriously negligent or
                    reckless actions. The consequences of the actions of the
                    Policyholder in a state of derangement or under psychiatric
                    treatment is likewise not covered;
                  </p>
                </div>

                <div className="flex">
                  <span className="font-semibold text-gray-700 min-w-6">
                    b)
                  </span>
                  <p className="text-gray-600 ml-2">
                    Events arising from terrorism, mutiny, large concentrations
                    of people, crowd disturbances and human stampedes. These may
                    be related, but are not limited to entertainment events,
                    sporting events, religious events, funeral processions,
                    riots, power failure, goods distribution, escalators and
                    moving walkways, insurrections, commotions or other similar
                    occurrences;
                  </p>
                </div>

                <div className="flex">
                  <span className="font-semibold text-gray-700 min-w-6">
                    c)
                  </span>
                  <p className="text-gray-600 ml-2">
                    Events or actions of the Armed Forces or Security Forces in
                    peacetime;
                  </p>
                </div>

                <div className="flex">
                  <span className="font-semibold text-gray-700 min-w-6">
                    d)
                  </span>
                  <p className="text-gray-600 ml-2">
                    Wars, with or without prior declaration, and any conflicts
                    or international interventions using force or duress;
                  </p>
                </div>

                <div className="flex">
                  <span className="font-semibold text-gray-700 min-w-6">
                    e)
                  </span>
                  <p className="text-gray-600 ml-2">
                    Those derived from radioactive nuclear energy;
                  </p>
                </div>

                <div className="flex">
                  <span className="font-semibold text-gray-700 min-w-6">
                    f)
                  </span>
                  <p className="text-gray-600 ml-2">
                    Those caused when the Policyholder takes part in bets,
                    challenges or brawls, except in the case of legitimate
                    defense or necessity;
                  </p>
                </div>

                <div className="flex">
                  <span className="font-semibold text-gray-700 min-w-6">
                    g)
                  </span>
                  <p className="text-gray-600 ml-2">
                    Illness or injuries existing prior to the claim, unless
                    expressly included in the Specific Conditions and subject to
                    payment of the relevant surcharge premium;
                  </p>
                </div>

                <div className="flex">
                  <span className="font-semibold text-gray-700 min-w-6">
                    h)
                  </span>
                  <p className="text-gray-600 ml-2">
                    Those that occur as a result of the participation by the
                    Policyholder in competitions, sports, and preparatory or
                    training tests;
                  </p>
                </div>

                <div className="flex">
                  <span className="font-semibold text-gray-700 min-w-6">
                    i)
                  </span>
                  <p className="text-gray-600 ml-2">Extra Hazardous Sports;</p>
                </div>

                <div className="flex">
                  <span className="font-semibold text-gray-700 min-w-6">
                    j)
                  </span>
                  <p className="text-gray-600 ml-2">
                    Participation in competitions or tournaments organized by
                    sporting federations or similar organizations unless
                    specifically approved by the Company;
                  </p>
                </div>

                <div className="flex">
                  <span className="font-semibold text-gray-700 min-w-6">
                    k)
                  </span>
                  <p className="text-gray-600 ml-2">
                    The use, as a passenger or crew, of means of air navigation
                    including helicopters not authorized for the public
                    transport of travellers;
                  </p>
                </div>

                <div className="flex">
                  <span className="font-semibold text-gray-700 min-w-6">
                    l)
                  </span>
                  <p className="text-gray-600 ml-2">
                    The accidents deemed legally to be work or labor accidents,
                    consequence of a risk inherent to the work performed by the
                    Policyholder.
                  </p>
                </div>
              </div>
            </section>

            <section>
              <h3 className="font-bold text-gray-800 mb-3">
                2. In addition to the previous exclusions, the following benefits
                are not covered by this policy:
              </h3>

              <div className="space-y-2 ml-4">
                <div className="flex">
                  <span className="font-semibold text-gray-700 min-w-6">
                    a)
                  </span>
                  <p className="text-gray-600 ml-2">
                    The services arranged by the Policyholder on his/her own
                    behalf, without prior communication or without the consent
                    of Company's service provider except in the case of
                    emergencies, in which case, the Policyholder must furnish
                    the Company with the vouchers and original copies of the
                    invoices;
                  </p>
                </div>

                <div className="flex">
                  <span className="font-semibold text-gray-700 min-w-6">
                    b)
                  </span>
                  <p className="text-gray-600 ml-2">
                    Pre-existing Illnesses or injuries arising from chronic
                    ailments or from those that existed prior to the inception
                    date of the policy;
                  </p>
                </div>

                <div className="flex">
                  <span className="font-semibold text-gray-700 min-w-6">
                    c)
                  </span>
                  <p className="text-gray-600 ml-2">
                    Death as a result of suicide and the injuries or aftereffect
                    brought about by attempted suicide;
                  </p>
                </div>

                <div className="flex">
                  <span className="font-semibold text-gray-700 min-w-6">
                    d)
                  </span>
                  <p className="text-gray-600 ml-2">
                    Those derived from illnesses or pathological states caused
                    by the voluntary consumption of alcohol, drugs, toxic
                    substances, narcotics or medicines acquired without medical
                    prescription, as well as any kind of mental illness or
                    mental imbalance;
                  </p>
                </div>

                <div className="flex">
                  <span className="font-semibold text-gray-700 min-w-6">
                    e)
                  </span>
                  <p className="text-gray-600 ml-2">
                    HIV, AIDS, sexually transmitted and venereal diseases;
                  </p>
                </div>

                <div className="flex">
                  <span className="font-semibold text-gray-700 min-w-6">
                    f)
                  </span>
                  <p className="text-gray-600 ml-2">Epidemics/Pandemic;</p>
                </div>

                <div className="flex">
                  <span className="font-semibold text-gray-700 min-w-6">
                    g)
                  </span>
                  <p className="text-gray-600 ml-2">
                    Those derived from renunciation of or delay, on the part of
                    the Policyholder or persons responsible for him/her, in the
                    transfer proposed by the Company and agreed by its medical
                    service;
                  </p>
                </div>

                <div className="flex">
                  <span className="font-semibold text-gray-700 min-w-6">
                    h)
                  </span>
                  <p className="text-gray-600 ml-2">
                    Rehabilitation treatments;
                  </p>
                </div>

                <div className="flex">
                  <span className="font-semibold text-gray-700 min-w-6">
                    i)
                  </span>
                  <p className="text-gray-600 ml-2">
                    Alternative medicines & procedures such as chiropractic
                    procedures, acupuncture, herbal medicines and other similar
                    procedures and treatment;
                  </p>
                </div>

                <div className="flex">
                  <span className="font-semibold text-gray-700 min-w-6">
                    j)
                  </span>
                  <p className="text-gray-600 ml-2">
                    Prosthesis, orthopedic material or orthesis and
                    osteosynthesis material, as well as spectacles;
                  </p>
                </div>

                <div className="flex">
                  <span className="font-semibold text-gray-700 min-w-6">
                    k)
                  </span>
                  <p className="text-gray-600 ml-2">
                    Those derived from pregnancy and childbirth, or for a
                    complication therefore or voluntary termination of
                    pregnancy;
                  </p>
                </div>

                <div className="flex">
                  <span className="font-semibold text-gray-700 min-w-6">
                    l)
                  </span>
                  <p className="text-gray-600 ml-2">
                    Those derived from baggage that is not sufficiently
                    identified, as well as fragile/breakable baggage or
                    perishable products;
                  </p>
                </div>

                <div className="flex">
                  <span className="font-semibold text-gray-700 min-w-6">
                    m)
                  </span>
                  <div className="ml-2">
                    <p className="text-gray-600 mb-2">
                      Assistance or compensation for events that occurred during
                      a trip that had commenced, in any of the following
                      circumstances:
                    </p>
                    <ul className="list-disc list-inside text-gray-600 ml-4 space-y-1">
                      <li>Before this insurance comes into force;</li>
                      <li>
                        With the intention of receiving medical treatment;
                      </li>
                      <li>After the diagnosis of a terminal illness; or</li>
                      <li>
                        Without prior medical authorization, after the
                        Policyholder had been under treatment or medical
                        supervision during the twelve (12) months prior to the
                        start of the trip.
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="flex">
                  <span className="font-semibold text-gray-700 min-w-6">
                    n)
                  </span>
                  <p className="text-gray-600 ml-2">
                    Expenses that arise or incurred beyond the scope of
                    application of the guarantees of the insurance, and, in any
                    case, after the dates of the travel object of the Agreement
                    have elapsed.
                  </p>
                </div>
              </div>
            </section>

            <section>
              <p className="text-gray-600">
                3. The Company is exempt of liability when, as a result of force
                majeure, it is unable to put into effect any of the benefits
                specifically envisaged in this policy.
              </p>
            </section>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Covered;
